export function handleTabKey(event) {
  const el = event.target;
  const start = el.selectionStart;
  const end = el.selectionEnd;
  el.value = el.value.substring(0, start) + "    " + el.value.substring(end);
  el.selectionStart = el.selectionEnd = start + 4;
  el.dispatchEvent(new Event("input"));
  event.preventDefault();
}
